// src/components/MessageBubble.js

import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Bubble = styled(Box)(({ theme, isCurrentUser }) => ({
    backgroundColor: isCurrentUser ? theme.palette.primary.main : theme.palette.grey[100],
    color: isCurrentUser ? theme.palette.common.white : theme.palette.text.primary,
    padding: theme.spacing(1, 2),
    borderRadius: 20,
    maxWidth: '70%',
    marginBottom: theme.spacing(1),
    alignSelf: isCurrentUser ? 'flex-end' : 'flex-start',
}));

const MessageBubble = ({ isCurrentUser, children }) => {
    return (
        <Bubble isCurrentUser={isCurrentUser}>
            <Typography variant="body2">{children}</Typography>
        </Bubble>
    );
};

export default MessageBubble;
